// ============================================================
// Approval Module — Router (index.tsx)
// Lazy-loads all sub-routes for the Approval module.
// Angular source: ApprovalModule
// ============================================================
import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const SmcEdit = lazy(() => import('./smc-edit/SmcEdit'));
const NgoRegistrationApproval = lazy(
  () => import('./ngo-registration-approval/NgoRegistrationApproval')
);
const NgoStateDistrictApproval = lazy(
  () => import('./ngo-state-district-approval/NgoStateDistrictApproval')
);
const RteStateFeeFix = lazy(() => import('./rte-state-fee-fix/RteStateFeeFix'));
const RteIntakeCapacity = lazy(
  () => import('./rte-intake-capacity/RteIntakeCapacity')
);
const SchoolSupport = lazy(() => import('./school-support/SchoolSupport'));
const SchemesDistributionAdminPanel = lazy(
  () => import('./sd-admin-panel/SchemesDistributionAdminPanel')
);
const NominalUpdation = lazy(
  () => import('./nominal-updation/NominalUpdation')
);
const ClassChangeApproval = lazy(
  () => import('./class-change-approval/ClassChangeApproval')
);
const ChangeProfileRequest = lazy(
  () => import('./change-profile-request/ChangeProfileRequest')
);
const BankAccountVerify = lazy(
  () => import('./bank-account-verify/BankAccountVerify')
);
// const VocationalTemplates = lazy(
//   () => import('./vocational-templates/VocationalTemplates')
// );
const StudentReadmissionApproval = lazy(
  () => import('./std-readmission-approval/StudentReadmissionApproval')
);
const ClubsAdminPanel = lazy(
  () => import('./clubs-admin-panel/clubs-admin-panel')
);
const AgParas = lazy(() => import('./ag-paras/AgParas'));
const StfForm = lazy(() => import('./stf-form/StfForm'));
const IndentDashboard = lazy(
  () => import('./indent-dashboard/IndentDashboard')
);
// const AgParas = lazy(() => import('./ag-paras/AgParas'));
// const StfForm = lazy(() => import('./stf-form/StfForm'));

// const TransportEscortAdminPanel = lazy(
//   () => import('./transport-escort-adminpanel/TransportEscortAdminPanel')
// );
// const TransportEscortApproval = lazy(
//   () => import('./transport-escort-approval/TransportEscortApproval')
// );
// const RstcMappingSchool = lazy(
//   () => import('./rstc-mapping-school/RstcMappingSchool')
// );
// const RstcMappingSchoolOld = lazy(
//   () => import('./rstc-mapping-school/RstcMappingSchoolOld')
// );
// const RstcExpenseManagement = lazy(
//   () => import('./rstc-expense-management/RstcExpenseManagement')
// );
// const EeTaxonomyUpdate = lazy(() => import('./ee-taxonomyid/EeTaxonomyUpdate'));
// const EeExcludingSchools = lazy(
//   () => import('./ee-excluding-schools/EeExcludingSchools')
// );
// const EeUploadQuestions = lazy(
//   () => import('./ee-upload-questions/EeUploadQuestions')
// );

// const IndentDashboard = lazy(
//   () => import('./indent-dashboard/IndentDashboard')
// );
// const EventGalleryReview = lazy(
//   () => import('./event-gallery-review/EventGalleryReview')
// );
const CoachingCentreApproval = lazy(
  () => import('./coaching-centre-approval/CoachingCentreApproval')
);
const CoachingCentreApprovalDetail = lazy(
  () => import('./coaching-centre-approval/CoachingCentreApprovalDetail')
);
const SmcValidation = lazy(() => import('./smc-validation/SmcValidation'));

const CoachingApproval = lazy(
  () => import('./coaching-approval/CoachingApproval')
);

const ApprovalModule: React.FC = () => {
  return (
    <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
      <Routes>
        <Route path="smc_edit" element={<SmcEdit />} />
        <Route
          path="ngo-registration-approval"
          element={<NgoRegistrationApproval />}
        />
        <Route
          path="ngo-registration-statedis-approval"
          element={<NgoStateDistrictApproval />}
        />
        <Route path="rte_state_fee_fix" element={<RteStateFeeFix />} />
        <Route path="rte-intake" element={<RteIntakeCapacity />} />
        <Route path="school-support" element={<SchoolSupport />} />
        <Route
          path="sd-admin-panel"
          element={<SchemesDistributionAdminPanel />}
        />
        <Route path="nominal-updation" element={<NominalUpdation />} />
        <Route path="class-change-approval" element={<ClassChangeApproval />} />
        <Route
          path="change-profile-request"
          element={<ChangeProfileRequest />}
        />
        {/* <Route path="pending-ag-paras" element={<AgParas />} />
        <Route path="stf-form" element={<StfForm />} /> */}
        {/* <Route path="indent-dashboard" element={<IndentDashboard />} /> */}
        <Route path="bank-account-verify" element={<BankAccountVerify />} />
        <Route
          path="std-readmission-approval"
          element={<StudentReadmissionApproval />}
        />
        {/* <Route path="vocational-templates" element={<VocationalTemplates />} /> */}
        <Route path="clubs-admin-panel" element={<ClubsAdminPanel />} />
        {/* <Route path="vocational-templates" element={<VocationalTemplates />} /> */}
        {/* <Route path="event-gallery-review" element={<EventGalleryReview />} /> */}
        {/* <Route
          path="transport-escort-adminpanel"
          element={<TransportEscortAdminPanel />}
        />
        <Route
          path="transport-escort-approval"
          element={<TransportEscortApproval />}
        />
        <Route path="rstc-mapping-school" element={<RstcMappingSchool />} />
        <Route path="rstc-old" element={<RstcMappingSchoolOld />} /> */}
        {/* <Route
          path="rstc-expense-management"
          element={<RstcExpenseManagement />}
        /> */}
        {/* <Route path="EETaxonomyAdd" element={<EeTaxonomyUpdate />} /> */}
        {/* <Route path="ee-excluding-schools" element={<EeExcludingSchools />} /> */}
        {/* <Route path="ee-upload" element={<EeUploadQuestions />} /> */}
        <Route path="coaching-centre" element={<CoachingCentreApproval />} />
        <Route
          path="coaching-centre/detail"
          element={<CoachingCentreApprovalDetail />}
        />
        <Route path="smc-validation" element={<SmcValidation />} />
      </Routes>
    </Suspense>
  );
};

export default ApprovalModule;
